import { render, staticRenderFns } from "./InstantTest.vue?vue&type=template&id=36e6e6aa"
import script from "./InstantTest.vue?vue&type=script&lang=js"
export * from "./InstantTest.vue?vue&type=script&lang=js"
import style0 from "./InstantTest.vue?vue&type=style&index=0&id=36e6e6aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports